// Converte il formato data di moment nel formato data
// del calendario di jQueryUI
module.exports = {
  // moment     // datepicker
  "DD/MM/YYYY": "dd/mm/yy",
  "DD/MM/YY": "dd/mm/y",
  "DD MMM YYYY": "dd M yy",
  "DD MMM": "dd M"
};
